import getUserAgent from './getUserAgent'

let ua = getUserAgent();

export default function (_url) {
  var url = 'mqqapi://forward/url?src_type=web&version=1&url_prefix=' + btoa(_url);

  //判断微信6.5.6客户端，这个客户端不允许使用schema跳转跳手Q
  var m = / MicroMessenger\/([0-9\.]+)/i.exec(navigator.userAgent);
  if (m && m[1] && compare(m[1], '6.5.6') >= 0) {
    window.WeixinJSBridge ? onWxJSBridgeReady() : document.addEventListener('WeixinJSBridgeReady', onWxJSBridgeReady);
    function onWxJSBridgeReady() {
      WeixinJSBridge.invoke('launchApplication', {
        schemeUrl: url
      }, function (res) {
        //如果没调起的话
        if (res.err_msg !== 'launchApplication:ok') {
          if (/Android/.test(navigator.userAgent)) {
            location.href = url;
          } else {
            WeixinJSBridge.invoke('launchApplication', {
              appID: 'mqqapi',
              parameter: url.replace(/^mqqapi:\/\//, '')
            }, function () {

            });
          }
        }
      });
    }
  } else if (ua.mqq) {
    location.href = _url;
  } else {
    location.href = url;
  }

  function compare(curV, reqV) {
    if (curV && reqV) {
      //将两个版本号拆成数字
      var arr1 = curV.split('.'),
        arr2 = reqV.split('.');
      var minLength = Math.min(arr1.length, arr2.length),
        position = 0,
        diff = 0;
      //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
      while (position < minLength && ((diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0)) {
        position++;
      }
      diff = (diff != 0) ? diff : (arr1.length - arr2.length);
      //若curV大于reqV，则返回true
      return diff;
    } else {
      //输入为空
      return -1;
    }
  }
}
